import axios from 'axios';
import authHeader from './../auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class AppointmentService {


    fetchDoctorSchedules(doctor_id, type) {
        return axios.get(`${API_URL}/doctors/${doctor_id}/doctorschedules/type/${type}`,);

    }

    createDoctorSchedule(doctorscheduleForm) {
        return doctorscheduleForm.post(`${API_URL}/doctorschedules`, {headers: authHeader()});
    }

    fetchCheckupPrescriptionFile(checkupprescription_id){
        return axios.get(`${API_URL}/checkupprescriptions/${checkupprescription_id}/pdf`, {headers: authHeader(), responseType: 'arraybuffer'});
    }

    fetchDoctorCheckupHistory(doctor_id, page_no) {
        return axios.get(`${API_URL}/doctors/${doctor_id}/patientcheckups/history?page=${page_no}` , {headers: authHeader()});
    }

    fetchUpcomingAppointments(doctor_id) {
        return axios.get(`${API_URL}/doctors/${doctor_id}/doctorappointments/upcoming`, {headers: authHeader()});

    }

}

export default new AppointmentService();
